import React from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import * as Icon from 'react-bootstrap-icons';
import ReactTimeAgo from 'react-time-ago'
import {MyReportProps} from '../components/types';
import {Bar, CartesianGrid, ComposedChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis,} from 'recharts';
import {Link} from "react-router-dom";


function row(quizResults, id, completedOn) {
    const data = [
        {
            name: 'O', score: quizResults.OPENNESS,
        },
        {
            name: 'C', score: quizResults.CONSCIENTIOUSNESS,
        },
        {
            name: 'E', score: quizResults.EXTROVERSION,
        },
        {
            name: 'A', score: quizResults.AGREEABLENESS,
        },
        {
            name: 'N', score: quizResults.NERVOSITY,
        },

    ];
    return (
        <tr key={id}>
            <td>
                <div style={{
                    height: 300,
                    position: 'relative',
                    minWidth: 200,
                    maxWidth: 1000
                }}>
                    <ResponsiveContainer>
                        <ComposedChart
                            width={1200}
                            height={200}
                            data={data}
                            margin={{
                                top: 5, right: 0, bottom: 5, left: 0,
                            }}
                        >
                            <CartesianGrid stroke="#f5f5f5"/>
                            <XAxis dataKey="name"/>
                            <YAxis/>
                            <Tooltip/>
                            <Legend/>
                            <Bar dataKey="score" barSize={20} fill="#cd9557"/>
                        </ComposedChart>
                    </ResponsiveContainer>
                </div>
</td>
            <td><ReactTimeAgo date={new Date(completedOn)}/></td>
            <td>
                <Button className="content-btn" variant="info" href={`/user/premium/view/${id}`}>
                    <Icon.EyeFill/> {" "}
                    View detailed report
                </Button><br /><br />
                <Button className="content-btn" variant="info" disabled>
                    <Icon.Download/> {" "}
                    Download
                </Button><br /><br />
                <Button className="content-btn" variant="info" disabled>
                    <Icon.TrashFill/> {" "}
                    Delete
                </Button>
            </td>
        </tr>
    )
}

function NoQuizData() {
    return (<div>
        <br/>
        <h3> You have not completed the assessment yet </h3>
        <Link to="/user/premium/quiz" className="intlink">Click here to start</Link>
    </div>)
}


function MyReports(props : MyReportProps) {

    if (!props.userData || props.userData?.quiz.length == 0) {
        return NoQuizData();
    }

    const sortedReports = props.userData.quiz
        .sort((a,b) => a.completedOn.localeCompare(b.completedOn))
        .reverse();

    return (
        <div>
            <br/>
            <h3>Here are the MyOceanity tests you have completed </h3>
            <h2><Link to="/user/premium/quiz" className="intlink">Click here to take a new assessment</Link></h2>
                
            <br/><br/>
            <Table striped bordered hover responsive>
                <thead>
                <tr>
                    <th>Overall results</th>
                    <th>Completed</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {sortedReports.map(quiz => {
                    return row(quiz.quizResults, quiz.quizId, quiz.completedOn);
                })}
                </tbody>
            </Table>


        </div>);
}

export default MyReports;